import React, { useContext, useState, useEffect } from "react";
import Home from "../Compo/Homes/Home";
import Projects from "../Compo/Projects/Project";
import ResumeNew from "../Compo/Resume/ResumeNew";
import {
  Accordion,
  Box,
  AccordionItem,
  AccordionButton,
  Stack,
  AccordionPanel,
  Radio,
  RadioGroup,
  Icon,
  AccordionIcon,
  Spinner,
} from "@chakra-ui/react";
import About from "./About";
import { BiColor, BiCircle } from "react-icons/bi";
import Contact from "./Contact";
import Footer from "./Footer";

import Skills from "./Skills";
import { context } from "../utility/ContextProvider";
import NavbarNew from "./NavbarNew";
import HomeNew from "./HomeNew";
import AboutNew from "./AboutNew";
import SkillsNew from "./SkillsNew";
import ProjectNew from "./ProjectNew";
import GithubNew from "./GithubNew";
import ContactNew from "./ContactNew";
import { AiOutlineArrowUp } from "react-icons/ai";

export const Portfolio = () => {
  const { textcolour ,colorChoose} = useContext(context);
 console.log(colorChoose)
  useEffect(() => {
    //change the gradient color
    const root = document.documentElement;
    if (colorChoose) {
      // User has selected a color, apply it
      const existingGradient = getComputedStyle(root).getPropertyValue("--gradient-2");
      const shadow_two = getComputedStyle(root).getPropertyValue("--shadow-2");
      
      const parts = existingGradient.split(/, /);
      const shadow_two_parts = shadow_two.split(" ");
      
      parts[3] = textcolour;
      shadow_two_parts[0] = textcolour;
      
      const updatedGradient = parts.join(", ");
      const updated_shadow_part_two = shadow_two_parts.join(" ");
      
      root.style.setProperty("--gradient-2", updatedGradient);
      root.style.setProperty("--shadow-2", updated_shadow_part_two);
    } 
    // else {
    //   // Use initial colors defined in :root
    //   root.style.setProperty("--gradient-2", "var(--gradient-2)");
    //   root.style.setProperty("--shadow-2", "var(--shadow-2)");
    // }
  }, [textcolour,colorChoose]);

  return (
    <div style={{ gap: "10px" }}>
      {/* <Home/> */}
      <HomeNew />

      {/* <About/> */}
      <AboutNew />
      <br />

      {/* <Skills/> */}
      <SkillsNew />
      <br />

      {/* <Projects/> */}
      <ProjectNew />
      <br />
      <GithubNew />

      {/* <Contact/> */}
      <br />
      <ContactNew />
      {/* 
<ResumeNew/> */}
      {/* <Footer/> */}
      <AccordianColour />
    </div>
  );
};

const AccordianColour = () => {
  const { textcolour, settextcolour ,setuserColorChoose } = useContext(context);

  const handlechangecolour = (e) => {
    settextcolour(e.target.value);
    setuserColorChoose(true)
  };

  return (
    <Accordion allowToggle direction="top" className="accordian-btn">
      <AccordionItem border="0">
        <h2>
          <AccordionButton fontSize="38px" _expanded={{ color: "white" }}>
            <Box as="span" flex="1" textAlign="left" fontSize="25px">
              <Icon as={BiColor} thickness="4px" className="spin-animation" />
            </Box>
            {/* <AccordionIcon fontSize="20px" /> */}
          </AccordionButton>
        </h2>
        <AccordionPanel fontSize="30px" gap={5}>
          <RadioGroup ml="10px">
            <Stack spacing={10}>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                backgroundColor="#FF8A65"
                fontSize="28px"
                colorScheme="#FF8A65"
                value="#FF8A65"
              ></Radio>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                backgroundColor="#BBDEFB"
                colorScheme="#BBDEFB"
                value="#BBDEFB"
              ></Radio>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                backgroundColor="#BA68C8"
                colorScheme="#BA68C8"
                value="#BA68C8"
              ></Radio>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                bg="#00BCD4"
                colorScheme="#00BCD4"
                value="skyblue"
              ></Radio>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                bg="#FFF176"
                colorScheme="#FFF176"
                value="yellow"
              ></Radio>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                color="#EA80FC"
                bg="#EA80FC"
                colorScheme="#EA80FC"
                value="pink"
              ></Radio>
              <Radio
                name="sortby"
                onChange={handlechangecolour}
                color="#0ea5ea"
                bg="#0ea5ea"
                colorScheme="#0ea5ea"
                value="#0ea5ea"
              ></Radio>
            </Stack>
          </RadioGroup>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
